import { EsploroOrganizationCategory } from './esploro-organization-category.enum';

export enum AffCategory {
    Internal = 'INTERNAL',
    External = 'EXTERNAL',
}

export class ListOwnership {
    public static INTERNAL = AffCategory.Internal.toLowerCase();
    public static EXTERNAL = AffCategory.External.toLowerCase();
}

export enum AffType {
    Current = 'current',
    Previous = 'previous',
}

export class ListType {
    public static CURRENT = AffType.Current;
    public static PREVIOUS = AffType.Previous;
}

export interface ResearcherOrganization {
    organizationCode: string;
    organizationName: string;
    organizationId: string;
    organizationCategory: EsploroOrganizationCategory;
}
